import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class CommentService {

    constructor(private httpClient: HttpClient) { }

    getNickNameList(nameFilter) {
        const params = new HttpParams().set('filter', JSON.stringify(nameFilter));
        return this.httpClient.get('users', { params: params });
    }
    getAllNickNameList() {
        return this.httpClient.get('users')
    }

    getUsersWithNickName() {
        let filter: any = {};
        filter.filter = JSON.stringify({
            where: {
                nickName: {
                    nlike: ""
                }
            }
        });
        return this.httpClient.get('users', { params: filter })
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/comment.service.ts